import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container max-md:px-0',
    wrapper: 'aspect-video align-top',
    video: 'h-full w-full [&>iframe]:h-full [&>iframe]:w-full'
  }
});
